var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"plain":_vm.plain,"size":_vm.size,"icon":_vm.icon,"type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.download}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }